import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { FormSection, formValueSelector } from 'redux-form';
import { get } from 'lodash';
import Divider from 'material-ui/Divider';

import { Person } from '@components/person';
import Address, { AddressField } from '@components/form/Address/Address';
import {
  Input,
  InputField,
  Date,
  DateField,
  RemoteAutoComplete,
  RemoteAutoCompleteField,
  InlineGridField,
  InlineGrid
} from '@components/form';
import { BicycleFormPhotos } from './BicycleFormPhotos';
import { ModalButton } from '@components/modalButton/ModalButton';
import { photosGridColumns } from './_bicyclesColumns';
import { BicyclesFormPhotosMultipleUploader } from './BicyclesFormPhotosMultipleUploader';
import { compose } from 'recompose';
import { connect } from 'react-redux';

const enhance = compose<any, any>(
  connect(state => {
    return {
      photos: formValueSelector('module-bicycles')(state, 'photos')
    };
  })
);

const View: React.SFC<any> = ({ photos }) => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col md={6} className="with-right-divider">
          <Row>
            <Col md={12}>
              <h4>Základní informace</h4>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <InputField component={Input} id={'frameNumber'} name={'frameNumber'} label={'Číslo rámu kola'} />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <DateField
                component={Date}
                dateOnly={false}
                id={'regDatetime'}
                name={'regDatetime'}
                label={'Datum a čas registrace'}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <DateField
                component={Date}
                dateOnly={false}
                id={'regValidDatetime'}
                name={'regValidDatetime'}
                label={'Datum a čas platnosti registrace'}
                allowFuture={true}
              />
            </Col>
          </Row>
          <Row>
            {[
              { name: 'brand', label: 'Značka', url: '/metropolis/api/bi/brands' },
              { name: 'color', label: 'Barva', url: '/metropolis/api/bi/colors' }
            ].map(({ name, label, url }) => (
              <Col md={12} key={name}>
                <RemoteAutoCompleteField
                  component={RemoteAutoComplete}
                  id={name}
                  name={name}
                  label={label}
                  url={url}
                  filterActive={true}
                  fullWidth={true}
                  labelFunction={o => get(o, 'name')}
                />
              </Col>
            ))}
          </Row>
          <Row>
            <Col md={12}>
              <InputField
                component={Input}
                id={'note'}
                name={'note'}
                label={'Poznámka'}
                multiLine={true}
                style={{ maxHeight: '60vh' }}
                inputStyle={{ maxHeight: '60vh' }}
                textareaStyle={{ maxHeight: '56vh' }}
              />
            </Col>
          </Row>
        </Col>
        <Col md={6} className="with-right-divider">
          <Row>
            <Col md={12}>
              <h4>Majitel</h4>
            </Col>
          </Row>
          <Col md={12}>
            <Row>
              <FormSection name="owner">
                <Person form={'module-bicycles'} formName="owner." />
              </FormSection>
              <AddressField component={Address} name={'owner.address'} />
            </Row>
          </Col>
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <h4>Fotografie</h4>
        </Col>
      </Row>
      {photos &&
        photos.length > 10 && (
          <Row>
            <Col md={12}>
              <h4 style={{ color: 'red' }}>Fotografií nesmí být více než 10!</h4>
            </Col>
          </Row>
        )}
      <Row>
        <Col md={12}>
          <InlineGridField
            component={InlineGrid}
            name="photos"
            Form={BicycleFormPhotos}
            ActionBar={() => (
              <div className="buttons">
                <ModalButton
                  label={'Přidat hromadně'}
                  style={{ marginLeft: 10 }}
                  disabled={photos && photos.length >= 10}
                  ModalComponent={BicyclesFormPhotosMultipleUploader}
                />
              </div>
            )}
            columns={photosGridColumns}
            showCheckboxes={true}
            adding={!photos || photos.length < 10}
            deleting={true}
          />
        </Col>
      </Row>
    </Grid>
    <Divider />
  </div>
);
export const BicycleFormBasic = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/bicycles/BicycleFormBasic.tsx